import { cva, type VariantProps } from "class-variance-authority";
import { type ComponentProps, type ForwardedRef, forwardRef } from "react";

import { TEMPLATE_TYPES } from "features/templates/constants";
import type { TemplateType } from "features/templates/types";

const templateTypeIconVariants = cva(
  "inline-flex shrink-0 items-center justify-center transition-[background] lg:group-hover:bg-white",
  {
    variants: {
      size: {
        xs: "size-6 rounded-lg [&_svg]:size-3",
        sm: "size-8 rounded-xl [&_svg]:size-4",
        md: "size-10 rounded-2xl [&_svg]:size-5",
        lg: "size-12 rounded-2xl [&_svg]:size-6",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
);

type TemplateTypeIconProps = Omit<ComponentProps<"span">, "children"> &
  VariantProps<typeof templateTypeIconVariants> & {
    type: TemplateType;
    isSelected?: boolean;
  };

function TemplateTypeIcon(
  { size, type, isSelected = false, ...props }: TemplateTypeIconProps,
  ref: ForwardedRef<HTMLSpanElement>,
) {
  const { icon: Icon } = TEMPLATE_TYPES[type];

  return (
    <span
      ref={ref}
      className={templateTypeIconVariants({
        size,
        className: isSelected ? "bg-white" : "bg-black-100",
      })}
      {...props}
    >
      <Icon weight="duotone" />
    </span>
  );
}

TemplateTypeIcon.displayName = "TemplateTypeIcon";

export default forwardRef(TemplateTypeIcon);
